/* global qalaCheckout */

jQuery( function( $ ) {
	if ( $( 'body' ).hasClass( 'woocommerce-checkout' ) && 'undefined' !== typeof qalaCheckout && qalaCheckout.forceReloadMinicart ) {
		setTimeout( () => wp.hooks.doAction( 'QALA_MINICART_FORCE_BACKGROUND_CART_UPDATE' ), 250 );
	}
} );
